import {
  GET_THEMES_SUCCESS,
  THEMES_LOADING,
  SET_THEME,
  GET_THEME_DETAILS_SUCCESS,
  GET_SCROLL_THEMES_SUCCESS,
} from "./Types";

export const GetThemesSuccess = (payload) => ({
  type: GET_THEMES_SUCCESS,
  payload,
});

export const ThemesLoading = (payload) => ({
  type: THEMES_LOADING,
  payload,
});

export const SetTheme = (payload) => ({
  type: SET_THEME,
  payload,
});

export const GetThemeDetailsSuccess = (payload) => ({
  type: GET_THEME_DETAILS_SUCCESS,
  payload,
});

export const GetScrollThemesSuccess = (payload) => ({
  type: GET_SCROLL_THEMES_SUCCESS,
  payload,
});
